import { api, apiSecure } from "../../components/api";






//GetToken for apicalls etc
const getToken = async () => {
  const credentials = 'as' //await SecureStore.getItemAsync("USER_AUTH");

  if (credentials) {
    const myJson = JSON.parse(credentials);
    //console.log("GetTokenasd", myJson.token);
    return myJson.token;
  }

  return false;
};

//Check if user are "loggedin"
const loadUser = () => async (dispatch) => {
  //Language
  const locale = localStorage.getItem('locale')
  console.log('loadUser locale', locale)

/*   dispatch({
    type: "UPDATE_LANGUAGE",
    payload: locale
  }); */


  //Auth
  //const token = await SecureStore.getItemAsync("AUTH_KEY");
  const credentials = JSON.parse(localStorage.getItem('USER_AUTH'))
  console.log("loadUser credentials", credentials);
  if (credentials && credentials.authenticated) {

      //Get User Data
      //console.log("loadUser requestGetUser");

      let req_config = {
        method: "POST",
        url: `/toimittaja_refreshuser`,
      };

      const response = await apiSecure.request(req_config).catch((error) => {
        console.log("Load user error", error);
      });

      
      if (!response) {
        await localStorage.setItem('USER_AUTH', JSON.stringify({
          accessToken: null,
          refreshToken: null,
          authenticated: false,
        }));

        dispatch({
          type: "USER_LOADED",
        });

        return;
      }

      const { data } = response;
      //console.log("loadUser2 RESP", data);



      dispatch({
        type: "LOGIN_SUCCESS",
        payload: {
          userid: data.user.id,
          tunnus: data.user.tunnus,
          name: data.user.name,
          yritys: data.user.yritys,
          tehtaat: data.user.tehtaat,
        },
      });

  } else {
    dispatch({
      type: "USER_LOADED",
    });
  }
};

//Try to login
const getUser = (userObj) => async (dispatch) => {
  const { username, password } = userObj;

  console.log('getUser', userObj)

  dispatch({
    type: "LOGIN_START"
  });

  let req_config = {
    method: "POST",
    url: `/toimittaja_login`,
    data: {
      email: username,
      password: password,
    },
  };

  const response = await api.request(req_config).catch(async (e) => {
    console.log("[getUser] catch((e)", e);
    //Alert.alert('Error!','Ei yhteyttä rajapintaan!')
  });

  console.log('getUser response', response)


  if (!response) {
    dispatch({
      type: "LOGIN_STOP"
    });

    return
  }

  const { data } = response;
  if (data.message === "user_loggedin") {
    //Data lokaalisti phoneen niin ei tarvitse joka kerta kirjautua uudelleen

    await localStorage.setItem('USER_AUTH', JSON.stringify({
      accessToken: data.accessToken,
      refreshToken: data.refreshToken,
      authenticated: true,
    }));

    const credentials = JSON.parse(localStorage.getItem('USER_AUTH'))

    console.log("getUser", credentials);

    dispatch({
      type: "LOGIN_SUCCESS",
        payload: {
          userid: data.user.id,
          tunnus: data.user.tunnus,
          name: data.user.name,
          yritys: data.user.yritys,
          tehtaat: data.user.tehtaat,
      },
    });
  } else {
    dispatch({
      type: "LOGIN_FAILED",
      payload: data.message,
    });
  }

  dispatch({
    type: "LOGIN_STOP"
  });
};




const logOut = () => async (dispatch) => {
  console.log("LOG_OUT Logging user out");
  //Tyhjennetään phonedata

  const credentials = JSON.parse(localStorage.getItem('USER_AUTH'))

  if (credentials) {
    let req_config = {
      method: "POST",
      url: `/toimittaja_logout`,
      data: {
        refreshToken: credentials.refreshToken,
      },
    };

    api(req_config)
    .then((response) => {
      console.log("RESPONSE FROM LOGOUT", response.data);
    })
    .catch((error) => {
      console.log("Error:", error);
    });
  }


  await localStorage.setItem('USER_AUTH', JSON.stringify({
    accessToken: null,
    refreshToken: null,
    authenticated: false,
  }));

  dispatch({
    type: "LOG_OUT",
  });
};




const updateAvatar = (avatarObj) => async (dispatch) => {
  console.log("updateAvatar");
  const { base64 } = avatarObj;
  if (!base64) return
  dispatch({
    type: "UPDATE_AVATAR",
    payload: base64
  });
};

const updateLang = (langObj) => async (dispatch) => {
  console.log("updateLang", langObj);
  if (!langObj) return

/*   await localStorage.setItem('locale', langObj) 

  dispatch({
    type: "UPDATE_LANGUAGE",
    payload: langObj
  }); */
};


/*

  const validateQrCode = () => {
    console.log("validateQrCode", id);
    setisLoading(true);
    console.log("validateQrCode");

    let req_config = {
      method: "POST",
      url: `/toimittaja_validateQrCode`,
      data: {
        deliveryId: id,
        qrcode:qrcode
      },
    };

    apiSecure(req_config)
      .then((response) => {
        console.log("RESPONSE", response.data);
        setDeliveryData(response.data.data);
        setisLoading(false);
      })
      .catch((error) => {
        console.log("Error:", error);
        setisLoading(false);
      });
  };


*/


const validateQrCode = (qrObj) => async (dispatch) => {

  console.log("validateQrCode", qrObj);
  if (!qrObj) return



  let req_config = {
    method: "POST",
    url: `/toimittaja_validateQrCode`,
    data: {
      qrcode:qrObj.qrcode
    },
  };

  api(req_config)
    .then((response) => {
      console.log("RESPONSE", response.data);
      if (response.data && response.data.status) {
        dispatch({
          type: "UPDATE_QRCODE",
          payload: qrObj.qrcode
        });
      }
    })
    .catch((error) => {
      console.log("Error:", error);
    });




  //await localStorage.setItem('locale', langObj) 
//
  //dispatch({
  //  type: "UPDATE_LANGUAGE",
  //  payload: langObj
  //});
};




export default {
  getUser,
  logOut,
  loadUser,
  getToken,
  updateAvatar,
  updateLang,
  validateQrCode
};
